import React from 'react'
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

function TypeEquipment() {
    return (
        <SettingsMetaData propertyName={"TypeEquipment"} viewPropertyName={"Type"} />
      );
}

export default TypeEquipment